import { FC } from 'react';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { ButtonIwText } from '@/_pages/interwill/components/ButtonIwText';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { SubstituteHandoverModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const SubstituteHandoverModal: FC<SubstituteHandoverModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'substituteHandover' });
  const { openModal, closeModal } = useModalsStore();

  const onDeclineClick = () => {
    closeModal();
    openModal({
      type: 'ConfirmHandoverModal',
      onConfirm: closeModal,
    });
  };

  return (
    <ModalContainerV2 title={t('title')} pinBottom>
      <Text>{t.rich('text')}</Text>
      <Buttons>
        <StyledTextButton onClick={closeModal}>{t('btnClose')}</StyledTextButton>
        <ButtonIw onClick={onDeclineClick}>{t('btnDecline')}</ButtonIw>
      </Buttons>
    </ModalContainerV2>
  );
};

const Text = styled.p`
  margin-top: 32px;
  font-size: 14px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 40px;
  font-size: 14px;
  line-height: 20px;
`;

const StyledTextButton = styled(ButtonIwText)`
  &&& {
    font-weight: 700;
  }
`;
